export default "__VITE_ASSET__aTmz4pS3__"